<template>
  <div class="border-2 bg-white" @dblclick.stop="">
    <button class="p-2 w-full" @click="data?.onElementClick">
      {{ data.label }}
    </button>

    <button
      v-if="data?.imageUrl"
      class="flex justify-center min-h-0 flex-1 overflow-auto"
      @click.stop="data?.onFigureClick"
    >
      <img :src="data.imageUrl" class="w-50" />
    </button>

    <div class="flex items-center justify-center border-t">
      <button
        @click.stop="data?.onAddElement"
        @dblclick.stop=""
        class="flex items-center justify-center hover:bg-primary-500 hover:text-white p-2"
      >
        <span class="material-symbols-outlined">add</span>
      </button>
      <button
        @click.stop="data?.onIsolateBranch"
        @dblclick.stop=""
        class="flex items-center justify-center hover:bg-primary-500 hover:text-white p-2"
      >
        <span class="material-symbols-outlined">arrow_and_edge</span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { type NodeProps } from "@vue-flow/core";

const { data } = defineProps<
  NodeProps<{
    label: string;
    imageUrl: string;
    onElementClick: () => void;
    onAddElement?: () => void;
    onIsolateBranch?: () => void;
    onFigureClick?: () => void;
  }>
>();
</script>
